import Vue from 'vue'
import VueRouter from "vue-router";
import routes from "./routes"

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  mode: "history",
});

router.afterEach((to,from)=>{
  if(to.meta.title){
    document.title = to.meta.title;
  }
})

export default router;